import { API } from '../../../vendor/api';
import { actionTypes } from '../constants';
export const downloadStatistic = (data) => async (dispatch, getState) => {
    try {
        const response = await API.extensionsAdmin.getFileStatistic(data);
        const url = window.URL.createObjectURL(await response.blob());
        const a = document.createElement('a');
        a.href = url;
        a.download = 'voyce-statistic.csv';
        a.click();
        dispatch({
            type: actionTypes.DOWNLOAD_STATISTICS,
        });
    }
    catch (errorMessage) {
        console.error(errorMessage);
    }
};
export const getStatisticsByParams = (data) => async (dispatch, getState) => {
    try {
        const statistics = await API.extensionsAdmin.getStatisticsByParams(data);
        dispatch({
            type: actionTypes.GET_STATISTICS,
            payload: statistics,
        });
    }
    catch (e) {
        console.error('Error in action "getStatisticsByParams": ', e);
    }
};
export const clearExtensionStatistics = () => async (dispatch, getState) => {
    dispatch({
        type: actionTypes.CLEAR_STATISTICS,
    });
};
export const getInstitutionsList = (filterParams = {}) => async (dispatch, getState) => {
    const institutionsList = await API.institution.getInstitutionsList(filterParams);
    dispatch({
        type: actionTypes.SET_INSTITUTIONS_LIST,
        payload: institutionsList,
    });
};
